const Colors = {
  background: "#f2f2f2",
  border: "#dddddd",
  grey: "#8d8d8d",
  black: "#090707",
  white: "#ffffff",

  yellow: "#e5d23a",
  blue: "#3a66e5",
  red: "#e53a40",
};

export default Colors;
